import { enrichForkedSessionPromptForAgent } from '../enrich-forked-session-prompt-for-agent.js';
import { enrichIntegrationContentPromptForAgent } from '../enrich-integration-content-prompt-for-agent.js';
import { enrichPlanningSessionPromptForAgent } from '../../planning/enrich-planning-session-prompt-for-agent.js';
import { registerPlanningSessionTurn } from '../../planning/planning-session-turn-buffer.js';

export async function prepareAgentPromptText(params: {
  promptText: string;
  sessionId?: string;
  runId?: string;
  isNewSession: boolean;
  cloudApiBaseUrl?: string;
  getCloudAccessToken?: () => string;
}): Promise<{ agentPromptText: string; isPlanningSession: boolean }> {
  const { promptText, sessionId, runId, isNewSession, cloudApiBaseUrl, getCloudAccessToken } = params;
  let agentPromptText = promptText;
  let isPlanningSession = false;

  if (sessionId && cloudApiBaseUrl && getCloudAccessToken) {
    agentPromptText = await enrichForkedSessionPromptForAgent({
      sessionId,
      promptText,
      cloudApiBaseUrl,
      getCloudAccessToken,
    });
    const planningEnriched = await enrichPlanningSessionPromptForAgent({
      sessionId,
      promptText: agentPromptText,
      isNewSession,
      cloudApiBaseUrl,
      getCloudAccessToken,
    });
    agentPromptText = planningEnriched.promptText;
    isPlanningSession = planningEnriched.isPlanningSession;
  }

  if (isPlanningSession && runId) {
    registerPlanningSessionTurn(runId);
  }

  if (sessionId) {
    agentPromptText = enrichIntegrationContentPromptForAgent({
      sessionId,
      originalPromptText: promptText,
      agentPromptText,
    });
  }

  return { agentPromptText, isPlanningSession };
}
